import { DashboardManagementService } from '@/services/dashboardManagementService/dashboardManagementService';
import { DashboardGridResponse, RecentActivityResponseDto } from '@/types/dashboard.type';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

type DashboardState = {
  list: {
    data: DashboardGridResponse;
  };
  recentActivity: RecentActivityResponseDto | null;
  loading: boolean;
  error: string | null;
};
const initialState: DashboardState = {
  list: {
    data: {
      totalNotification: 0,
      totalProject: 0,
      totalSurvey: 0, // or any default
      totalUsers: 0,
    },
  },
  recentActivity: null,
  loading: false,
  error: null,
};

// Global flag to prevent multiple simultaneous fetches
let isFetching = false;
let hasFetchedOnce = false;

export const fetchDashboardInfo = createAsyncThunk(
  'dashboard/count',
  async (params: Record<string, any> | undefined, thunkAPI) => {
    if (isFetching) {
      return thunkAPI.rejectWithValue('Already fetching');
    }

    try {
      isFetching = true;
      const response = await DashboardManagementService.getDashboardInfo();
      hasFetchedOnce = true;
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    } finally {
      isFetching = false;
    }
  },
);

export const fetchRecentActivity = createAsyncThunk(
  'dashboard/recent-activity',
  async (params: Record<string, any> | undefined, thunkAPI) => {
    try {
      const response = await DashboardManagementService.getRecentActivity();
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  },
);

// ========================
//        SLICE
// ========================

const dashboardManagementSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardInfo.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.list.data = action.payload?.data || null;
      })
      .addCase(fetchDashboardInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(fetchRecentActivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecentActivity.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.recentActivity = action.payload || null;
      })
      .addCase(fetchRecentActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default dashboardManagementSlice.reducer;
